module.exports = __webpack_public_path__ + "static/img/06zidaicanju.dfdb6e8a.gif";